import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class LaborView extends Component{
    
    
    render() {     
                
        return (
            
                    <tr>
                        <td>
                            <p>{this.props.product.name}</p>                           
                            
                        </td>
                        <td>                             
                            <p>{formatQuantity(this.props.product.number)}</p>                                                       
                        </td>                       
                        <td>
                            <p>{formatPrice(this.props.product.price)}</p>                                                         
                        </td>
                        <td>
                            <p>{this.props.product.discount}%</p>
                        </td>                        
                        <td>
                            <p>{formatPrice(this.props.product.total)}</p>
                            
                        </td>
                    </tr>
                
 
        );
    }
}

export default  LaborView;


// WEBPACK FOOTER //
// ./src/components/LaborView.js